import React, {useState} from 'react';
import MyIput from './UI/Button/Input/MyIput';
import MyButton from './UI/Button/MyButton';

export default function PostForm({createPost}) {
   const [post, setPost] = useState({ title: '', body: '' })
   const addpost = (e) => {
      e.preventDefault();
      const newPost = {
         ...post,
         id: Date.now()
      }
      createPost(newPost)
      setPost({title: '', body: ''})
   }
   return (
      <form>
               <h5 className="text-center">Create your first post</h5>
               <MyIput
                  type="text"
                  className="form-control"
                  placeholder="Programming Language"
                  value={post.title}
                  onChange={e => setPost({...post, title: e.target.value})}
               />
                  
               <MyIput
                  type="text"
                  className="form-control my-3"
                  placeholder="Enter your Favorite Stack"
                  value={post.body}
                  onChange={e => setPost({...post, body: e.target.value})}
               />
               <MyButton className="btn btn-primary w-100" onClick={addpost} >Add Post</MyButton>
            </form>
   )
}
